import BtnCart from "../components/order/BtnCart";
import Cart from "../components/order/Cart";

if (document.getElementById('bag')) {
    new Vue({
        el: '#bag',
        components: {
            BtnCart
        },
    });
}

if (document.getElementById('cart')) {
    new Vue({
        el: '#cart',
        components: {
            Cart
        },
    });
}


// WEBPACK FOOTER //
// ./resources/assets/js/snippets/order.js